import { render, staticRenderFns } from "./AccountingOpeningForm.vue?vue&type=template&id=288826aa&"
import script from "./AccountingOpeningForm.vue?vue&type=script&lang=js&"
export * from "./AccountingOpeningForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports